import _ from "lodash";
import {update, reset} from "../../viewmodel/other/clientSelectViewModel";
import TokenService from "../../service/sso/TokenService";
import BusinessConstants from "../../constant/BusinessConstants";
import HzwjwService from "../../service/noAuth/HzwjwService";


const getDataContext = getState => getState().other.clientSelectViewModel;


const init = () => {


};

const selectLogin = (record) => {
    return async (dispatch, getState) => {
        const {token, smsCode, mobile} = getDataContext(getState);
        await HzwjwService.noLoginAsync({
            userId: record.id,
        });
        if (record.hospital.id === "ROOT") {
            const {token: ssoToken} = await TokenService.getTokenAsync({
                userId: record.id,
            });
            const url = new URL("cms/pc/swjwindex.html", location.origin);
            url.searchParams.set("sso_token", ssoToken);
            location.replace(url.toString());
        } else {
            const url = new URL("renyuan/pc/index.html", location.origin);
            location.replace(url.toString());
        }
    };
};


export default {
    init,
    update,
    reset,
    selectLogin,
};
